import { render } from "./AuthPortalHead.vue?vue&type=template&id=cd80368c&scoped=true"
import script from "./AuthPortalHead.vue?vue&type=script&lang=js"
export * from "./AuthPortalHead.vue?vue&type=script&lang=js"

import "./AuthPortalHead.vue?vue&type=style&index=0&id=cd80368c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd80368c"]])

export default __exports__